import React from 'react';
import { Link, browserHistory } from 'react-router';
import { Button, Dialog } from "@blueprintjs/core";
import { connect } from 'react-redux';
import {
  DropDownChonPhongBanThuocCoQuan,
  DropDownChonCanBoXuLy,
  DropDownChonPhoPhong
} from 'components/tt-forms';
import {
  DropDown
} from 'components/tt-forms/common';
import { ShowIf } from 'components/utils';
import { processType } from 'constants/process-type';
import { validatable } from 'components/utils';
import { LetterProcessingWorkFlow } from 'api';
import { Toastr } from 'modules/toastr';

let classNames = require('classnames');

class ConfirmDialog extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: false,

      phongBanGiaiQuyet: '',
      canBoChiDinh: '',
      openDialog: false,
      dataComboboxTuXuLyTruongPhong: [
        {type: 'TU_GIAI_QUYET', name: 'Tự giải quyết'},
        {type: 'CHUYEN_PHONG_BAN_KHAC', name: 'Chuyển phòng ban khác'},
        {type: 'GIAO_VIEC_PHO_PHONG', name: 'Giao việc phó phòng'},
        {type: 'GIAO_VIEC_CHUYEN_VIEN', name: 'Giao việc chuyên viên'},
      ],
      dataComboboxTuXuLyChuyenVien: [
        {type: 'TU_GIAI_QUYET', name: 'Tự giải quyết'},
        {type: 'CHUYEN_PHONG_BAN_KHAC', name: 'Chuyển phòng ban khác'}
      ],
      statusKetThucXLD: 'TU_GIAI_QUYET'
    };
  }

  componentDidMount() {
    if (this.props.chuyenVienXLD === true) {
      this.setState({
        canBoChiDinh: this.props.userInfo.id
      })
    }
  }

  handleChange(name, e) {
    let newState = {
      ...this.state,
      [name]: e.target.value
    }

    if (name === 'statusKetThucXLD' && e.target.value === 'TU_GIAI_QUYET') {
      newState = {
        ...newState,
        canBoChiDinh: this.props.userInfo.id
      }
    }

    if (name === 'statusKetThucXLD' && e.target.value === 'CHUYEN_PHONG_BAN_KHAC') {
      newState = {
        ...newState,
        canBoChiDinh: ''
      }
    }

    this.setState({
      ...newState
    })
  }

  closeDialog() {
    if (!this.props.buttonShow) {
      this.props.onClose();
    }
    this.setState({ openDialog: false });

  }

  openDialog() {
    if (this.props.validateSubmitForm()) {
      this.setState({
        openDialog: true
      })
    }
  }

  onSuccess() {
    if (this.props.type === 'XLD') {

      if (this.props.params.huongXuLy == processType.xuLyDon.huongXuLy.deXuatThuLy && this.props.params.trangThaiTTXM === "TU_TTXM") {

        if (this.props.validateSubmitForm()) {
          let params = this.getParams();
          let noticeMsg = params.notice;

          this.setState({
            loading: true,
          });

          if (this.props.alias === 'XuLyDonTuXuLy') {
            this.props.onClickSaveFile('BC_XLD', () => {
              LetterProcessingWorkFlow.actions.postTuXuLyDon.request('', params).then(res => {
                browserHistory.push('/xu-ly-don');
                Toastr(noticeMsg, 'success');
              }).catch(error => {
                if (error.response) {
                  Toastr(error.response.data.errors[0].detail, 'error');
                }
                this.setState({
                  loading: false,
                });
              });
            });
          } else {
            this.props.onClickSaveFile('BC_XLD', () => {
              LetterProcessingWorkFlow.actions.postXuLyDon.request('', params).then(res => {
                browserHistory.push('/xu-ly-don');
                Toastr(noticeMsg, 'success');
              }).catch(error => {
                if (error.response) {
                  Toastr(error.response.data.errors[0].detail, 'error');
                }
                this.setState({
                  loading: false,
                });
              });
            });
          }
        }

      } else {
        if (this.props.alias === 'XuLyDonTuXuLy') {
          this.props.onTuXuLy();
        } else {
          this.props.onSuccess();
        }
      }
    }
  }

  getParams() {
    let params = {
      ...this.props.params
    }

    delete params.messege;

    if (this.state.phongBanGiaiQuyet) {
      params.phongBanGiaiQuyet = {
        id: Number(this.state.phongBanGiaiQuyet)
      }
    }

    if (this.state.statusKetThucXLD !== 'CHUYEN_PHONG_BAN_KHAC') {
      params.phongBanGiaiQuyet = {
        id: Number(this.props.userInfo.coQuanQuanLyId)
      }
    }
    if (this.state.statusKetThucXLD !== 'GIAO_VIEC_CHUYEN_VIEN' && this.props.truongPhongXLD) {
      params.huongGiaiQuyetThuLy = 'CHUYEN_PHONG_BAN'
    } else if (this.props.truongPhongXLD) {
      params.huongGiaiQuyetThuLy = 'CHUYEN_CHUYEN_VIEN'
    }

    if (this.state.statusKetThucXLD !== 'TU_GIAI_QUYET' && this.props.chuyenVienXLD) {
      params.huongGiaiQuyetThuLy = 'CHUYEN_PHONG_BAN'
    } else if (this.props.chuyenVienXLD) {
      params.huongGiaiQuyetThuLy = 'CHUYEN_CHUYEN_VIEN'
    }

    if (this.state.canBoChiDinh) {
      params.canBoXuLyChiDinh = {
        id: Number(this.state.canBoChiDinh)
      }
    }
    return params
  }

  componentWillMount() {

    if (this.props.userInfo && this.props.alias != 'XuLyDonTuXuLy' && this.props.alias === 'LeaderAction') {
      this.setState({
        canBoChiDinh: this.props.userInfo.id
      });
    }
  }

  trigger() {

    let params = {
      ...this.props.params
    }

    if (this.state.phongBanGiaiQuyet) {
      params.phongBanGiaiQuyet = {
        id: Number(this.state.phongBanGiaiQuyet)
      }
    } else {
      params.phongBanGiaiQuyet = null;
    }

    if (this.state.canBoChiDinh) {
      params.canBoXuLyChiDinh = {
        id: Number(this.state.canBoChiDinh)
      }
    } else {
      params.canBoXuLyChiDinh = null;
    }
    this.props.onChange(params);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.btnSaveLoading == true) {
      this.setState({ loading: nextProps.btnSaveLoading });
    }
    if (nextProps.btnLoading == true) {
      this.setState({ loading: nextProps.btnLoading });
    }
  }

  render() {
    let classes = ['reception-dialog-text'];

    if (this.props.type === 'XLD' && (this.props.params && this.props.params.huongXuLy == processType.xuLyDon.huongXuLy.deXuatThuLy && this.props.params.trangThaiTTXM === 'TU_TTXM')) {
      classes.push('txt-left');
    }

    return (
      <div>
        <ShowIf condition={this.props.buttonShow && this.props.alias !== 'WordProcessingSpecialistActionNoProcess'}>
          <Button type="button" className="btn-action btn-move btn-green right"
            onClick={this.openDialog.bind(this)}>Chuyển giải quyết đơn</Button>
        </ShowIf>

        <Dialog
          isOpen={this.props.buttonShow ? this.state.openDialog : this.props.open}
          onClose={this.closeDialog.bind(this)}
          title={this.props.title}
          className="reception-dialog delete-dialog wrap-block">

          <div className="pt-dialog-body">
            <p className={classNames(classes)}>{this.props.content}</p>
          </div>

          <ShowIf condition={this.props.type === 'XLD' && (this.props.chuyenVienXLD !== true || !this.props.params.trangThaiTTXM === 'TU_TTXM') && (this.props.truongPhongXLD !== true || !this.props.params.trangThaiTTXM === 'TU_TTXM')}>
            <div className='row pl30 pr30 pb10'>
              <ShowIf condition={this.props.params && this.props.params.huongXuLy == processType.xuLyDon.huongXuLy.deXuatThuLy && this.props.params.trangThaiTTXM === 'TU_TTXM'}>
                <DropDownChonPhongBanThuocCoQuan require
                  selectedValue={this.state.phongBanGiaiQuyet}
                  label="Phòng ban giải quyết"
                  className="col-50"
                  onChange={this.handleChange.bind(this, 'phongBanGiaiQuyet')}
                  bindValidator={this}
                  name="dropdownChonPhongBanThuocCoQuan" />

                <DropDownChonCanBoXuLy require
                  bindValidator={this}
                  className="col-50"
                  label="Công chức xử lý"
                  vaiTro="CHUYEN_VIEN"
                  selectedValue={this.state.canBoChiDinh}
                  phongBanId={this.state.phongBanGiaiQuyet}
                  onChange={this.handleChange.bind(this, 'canBoChiDinh')}
                  name="dropdownChonCanBoXuLy" />
              </ShowIf>
              <div className='col-100 no-gutter'>
                <div className="row pt5 pb10">
                  <span className="line-border"></span>
                </div>
              </div>
            </div>
          </ShowIf>

          <ShowIf condition={this.props.type === 'XLD' && this.props.chuyenVienXLD !== true && this.props.truongPhongXLD === true && this.props.params.trangThaiTTXM === 'TU_TTXM'}>
            <div className='row pl30 pr30 pb10'>
              <ShowIf condition={this.props.params && this.props.params.huongXuLy == processType.xuLyDon.huongXuLy.deXuatThuLy && this.props.params.trangThaiTTXM === 'TU_TTXM'}>
                <div>
                  <DropDown require
                    selectedValue={this.state.statusKetThucXLD}
                    options={this.state.dataComboboxTuXuLyTruongPhong}
                    label="Hướng chuyển giải quyết đơn"
                    className="col-50"
                    keyName='type'
                    valueName='name'
                    onChange={this.handleChange.bind(this, 'statusKetThucXLD')}
                    bindValidator={this}
                    name="statusKetThucXLD"/>
                  <ShowIf condition={this.state.statusKetThucXLD === 'TU_GIAI_QUYET' && this.props.chonTruongPhong}>
                    <DropDownChonCanBoXuLy require
                      bindValidator={this}
                      className="col-50"
                      label="Trưởng phòng xử lý"
                      vaiTro="TRUONG_PHONG"
                      selectedValue={this.state.canBoChiDinh}
                      phongBanId={this.props.userInfo.coQuanQuanLyId}
                      onChange={this.handleChange.bind(this, 'canBoChiDinh')}
                      name="dropdownChonCanBoXuLy" />
                  </ShowIf>
                  <ShowIf condition={this.state.statusKetThucXLD === 'CHUYEN_PHONG_BAN_KHAC'}>
                    <DropDownChonPhongBanThuocCoQuan require
                      selectedValue={this.state.phongBanGiaiQuyet}
                      label="Phòng ban tiếp nhận"
                      className="col-50"
                      isOther={true}
                      phongBanGiaiQuyet={this.props.userInfo.coQuanQuanLyId}
                      onChange={this.handleChange.bind(this, 'phongBanGiaiQuyet')}
                      bindValidator={this}
                      name="dropdownChonPhongBanThuocCoQuan" />
                  </ShowIf>
                  <ShowIf condition={this.state.statusKetThucXLD === 'GIAO_VIEC_PHO_PHONG'}>
                    <DropDownChonPhoPhong require
                      bindValidator={this}
                      className="col-50"
                      label="Phó phòng xử lý"
                      vaiTro="PHO_PHONG"
                      selectedValue={this.state.canBoChiDinh}
                      phongBanId={this.props.userInfo.coQuanQuanLyId}
                      onChange={this.handleChange.bind(this, 'canBoChiDinh')}
                      name="DropDownChonPhoPhong" />
                  </ShowIf>
                  <ShowIf condition={this.state.statusKetThucXLD === 'GIAO_VIEC_CHUYEN_VIEN'}>
                    <DropDownChonCanBoXuLy require
                      bindValidator={this}
                      className="col-50"
                      label="Công chức xử lý"
                      vaiTro="CHUYEN_VIEN"
                      selectedValue={this.state.canBoChiDinh}
                      phongBanId={this.props.userInfo.coQuanQuanLyId}
                      onChange={this.handleChange.bind(this, 'canBoChiDinh')}
                      name="dropdownChonCanBoXuLy" />
                  </ShowIf>
                </div>
              </ShowIf>
              <div className='col-100 no-gutter'>
                <div className="row pt5 pb10">
                  <span className="line-border"></span>
                </div>
              </div>
            </div>
          </ShowIf>

          <ShowIf condition={this.props.type === 'XLD' && this.props.chuyenVienXLD === true && this.props.truongPhongXLD !== true && this.props.params.trangThaiTTXM === 'TU_TTXM'}>
            <div className='row pl30 pr30 pb10'>
              <ShowIf condition={this.props.params && this.props.params.huongXuLy == processType.xuLyDon.huongXuLy.deXuatThuLy && this.props.params.trangThaiTTXM === 'TU_TTXM'}>
                <div>
                  <DropDown require
                    selectedValue={this.state.statusKetThucXLD}
                    options={this.state.dataComboboxTuXuLyChuyenVien}
                    label="Hướng chuyển giải quyết đơn"
                    className="col-50"
                    keyName='type'
                    valueName='name'
                    onChange={this.handleChange.bind(this, 'statusKetThucXLD')}
                    bindValidator={this}
                    name="statusKetThucXLD"/>
                  <ShowIf condition={this.state.statusKetThucXLD === 'TU_GIAI_QUYET' && this.props.chonChuyenVien}>
                    <DropDownChonCanBoXuLy require
                      bindValidator={this}
                      className="col-50"
                      label="Công chức xử lý"
                      vaiTro="CHUYEN_VIEN"
                      selectedValue={this.state.canBoChiDinh}
                      phongBanId={this.props.userInfo.coQuanQuanLyId}
                      onChange={this.handleChange.bind(this, 'canBoChiDinh')}
                      name="dropdownChonCanBoXuLy" />
                  </ShowIf>
                  <ShowIf condition={this.state.statusKetThucXLD === 'CHUYEN_PHONG_BAN_KHAC'}>
                    <DropDownChonPhongBanThuocCoQuan require
                      selectedValue={this.state.phongBanGiaiQuyet}
                      label="Phòng ban tiếp nhận"
                      className="col-50"
                      isOther={true}
                      phongBanGiaiQuyet={this.props.userInfo.coQuanQuanLyId}
                      onChange={this.handleChange.bind(this, 'phongBanGiaiQuyet')}
                      bindValidator={this}
                      name="dropdownChonPhongBanThuocCoQuan" />
                  </ShowIf>
                </div>
              </ShowIf>
              <div className='col-100 no-gutter'>
                <div className="row pt5 pb10">
                  <span className="line-border"></span>
                </div>
              </div>
            </div>
          </ShowIf>

          <div className="box-bottom col-100">
            <Link className="btn-action btn-close action-todo" onClick={this.closeDialog.bind(this)}><span>Không</span></Link>
            <Link className={`btn-green ${this.state.loading ? 'btn-loading-inline' : ''}`} onClick={this.onSuccess.bind(this)}><span>Đồng ý</span></Link>
          </div>
        </Dialog>
      </div>

    );
  }
}

ConfirmDialog.defaultProps = {
  buttonShow: false,
  title: 'Xác nhận chuyển',
  content: 'Bạn có muốn chuyển giải quyết đơn?',
  onSuccess: function () {
    console.log('Need to assign onSuccess method');
  },
  validate: false,
  onClose: function () {
    console.log('Need to assign onClose method');
  },
  chonTruongPhong: false,
  chonChuyenVien: true
}

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
  }
}

export default connect(bindStateToProps)(validatable(ConfirmDialog));



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/dialog/ConfirmDialog.jsx